/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Box breathing is four equal phases — inhale, hold, exhale, hold — each lasting the same count, often 4 seconds. One full round takes about 16 seconds, so a 1-minute timer covers roughly three to four rounds, enough to noticeably slow your heart rate.`)
};

const es_timer_u1m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La respiración cuadrada tiene cuatro fases iguales — inhalar, retener, exhalar, retener — cada una con la misma duración, a menudo 4 segundos. Una ronda completa toma unos 16 segundos, así que un temporizador de 1 minuto cubre aproximadamente de tres a cuatro rondas, suficiente para reducir notablemente tu ritmo cardíaco.`)
};

const de_timer_u1m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Box-Breathing besteht aus vier gleich langen Phasen — einatmen, halten, ausatmen, halten —, jede mit derselben Zählzeit, oft 4 Sekunden. Eine volle Runde dauert etwa 16 Sekunden, ein 1-Minuten-Timer deckt also etwa drei bis vier Runden ab, genug, um die Herzfrequenz spürbar zu senken.`)
};

const nl_timer_u1m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Box-breathing bestaat uit vier gelijke fasen — inademen, vasthouden, uitademen, vasthouden — die elk even lang duren, vaak 4 seconden. Eén volledige ronde duurt ongeveer 16 seconden, dus een timer van 1 minuut dekt ruwweg drie tot vier rondes, genoeg om je hartslag merkbaar te vertragen.`)
};

const fr_timer_u1m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La respiration carrée se compose de quatre phases égales — inspiration, rétention, expiration, rétention — chacune durant le même temps, souvent 4 secondes. Un cycle complet dure environ 16 secondes, donc un minuteur d’une minute couvre environ trois à quatre cycles, assez pour ralentir sensiblement votre rythme cardiaque.`)
};

const it_timer_u1m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il box breathing consiste in quattro fasi uguali — inspirazione, trattenimento, espirazione, trattenimento — ciascuna della stessa durata, spesso 4 secondi. Un ciclo completo richiede circa 16 secondi, quindi un timer di 1 minuto copre circa tre o quattro cicli, abbastanza per rallentare sensibilmente la frequenza cardiaca.`)
};

const pt_br2_timer_u1m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A respiração quadrada tem quatro fases iguais — inspirar, segurar, expirar, segurar — cada uma durando a mesma contagem, geralmente 4 segundos. Uma rodada completa leva cerca de 16 segundos, então um temporizador de 1 minuto cobre aproximadamente três a quatro rodadas, o suficiente para desacelerar visivelmente sua frequência cardíaca.`)
};

const pt_timer_u1m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A respiração em caixa tem quatro fases iguais — inspirar, suster, expirar, suster — cada uma com a mesma duração, muitas vezes 4 segundos. Uma ronda completa demora cerca de 16 segundos, por isso um temporizador de 1 minuto cobre aproximadamente três a quatro rondas, suficiente para desacelerar visivelmente o ritmo cardíaco.`)
};

const ja_timer_u1m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボックス呼吸は、吸う・止める・吐く・止めるの4つの等しいフェーズで構成され、それぞれ同じ長さ（多くは4秒）を保ちます。1ラウンドは約16秒かかるため、1分間のタイマーでおよそ3〜4ラウンドをカバーでき、心拍数を目に見えて落ち着かせるのに十分です。`)
};

const zh_timer_u1m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱式呼吸由四个等长阶段组成 — 吸气、屏息、呼气、屏息 — 每个阶段时长相同，通常为4秒。完整一轮约需16秒，因此1分钟计时器大约可以进行三到四轮，足以明显减缓心率。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1m_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1m_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1m_faq4_a", locale)
	if (locale === "en") return en_timer_u1m_faq4_a(inputs)
	if (locale === "es") return es_timer_u1m_faq4_a(inputs)
	if (locale === "de") return de_timer_u1m_faq4_a(inputs)
	if (locale === "nl") return nl_timer_u1m_faq4_a(inputs)
	if (locale === "fr") return fr_timer_u1m_faq4_a(inputs)
	if (locale === "it") return it_timer_u1m_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1m_faq4_a(inputs)
	if (locale === "pt") return pt_timer_u1m_faq4_a(inputs)
	if (locale === "ja") return ja_timer_u1m_faq4_a(inputs)
	return zh_timer_u1m_faq4_a(inputs)
};